const Permissions = {
  DELETE_INCIDENT_REPORT: 'delete_incident_report',
  DELETE_FORM_RESULT: 'delete_form_result',
  UPDATE_CLIENT: 'update_client',
  UPDATE_STAFF: 'update_staff',
  UPDATE_SITE: 'update_site',
  UPDATE_MOBILE_PATROL: 'update_mobile_patrol',
  UPDATE_TASK: 'update_task',
  UPDATE_TOUR: 'update_tour',
  UPDATE_INFO_NOTE: 'update_info_note',
  EDIT_INCIDENT_REPORTS: 'edit_incident_reports',
  APPROVE_INCIDENT_REPORTS: 'approve_incident_reports',
  REVIEW_INCIDENT_REPORT: 'review_incident_report',
  MANAGE_VISITORS: 'manage_visitors',
  REGISTER_VISIT: 'register_visit',
  UPDATE_SSO_CONFIGURATION: 'update_sso_configuration',
  EDIT_SUBMITTED_FORM: 'edit_submitted_form',
  EDIT_APPROVED_FORM: 'edit_approved_form',
  MANAGE_BRANCHES: 'manage_branches',
  MANAGE_ADMINISTRATORS: 'manage_administrators',
  CAN_FILL_FORM_ON_WEB: 'web_fill_form',
  UPDATE_COMPANY_MAX_SHIFT_HOURS: 'update_company_max_shift_hours',
  UPDATE_COMPANY_GPS_REQUIRED: 'update_company_gps_required',
  UPDATE_SITE_SCAN_TYPE: 'update_site_scan_type',
  VIEW_CHAT: 'view_chat',
  CHAT_SEND_MESSAGE: 'chat_send_message',
  CHAT_SEND_BRANCH_MESSAGE: 'chat_send_branch_message',
  CHAT_VIEW_FULL_HISTORY: 'chat_view_full_history',
};

const MenuPermissions = {
  CONTROL_PANEL: 'operations_dashboard_site',
  ACTIVITY_MONITOR: 'operations_dashboard',
  ACTIVITY_MAP: 'operations_dashboard_site',
  ACTIVITY_LOG: 'events_history',
  FORM_RESULTS: 'form_results_menu',
  INFO_BOARD: 'events_history',
  INCIDENT_REPORTS: 'incident_reports',
  VISITOR_LOG: 'visitor_log_menu',
  PDF_REPORTS: 'pdf_reports_menu',
  BI_AND_STATISTICS: 'bi_and_statistics_menu',
  PERFORMANCE: 'performance',
  WORK_HISTORY: 'events_history',
  TIMESHEETS: 'timesheets',
  CLIENTS: 'client_search',
  CONTACTS: 'client_search',
  SITES: 'site_search',
  TASKS: 'manage_tasks',
  TOURS: 'site_search',
  MOBILE_UNITS: 'mobile_patrol_search',
  ADMINISTRATORS: 'administrators_menu',
  EMPLOYEES: 'employee_search',
  VISITORS: 'visitors_menu',
  BRANCHES: 'menu_branches',
  FORMS: 'forms',
  SETTINGS: 'settings',
  SYSTEM_LOG: 'settings',
  ACCOUNT_INFO: 'my_account',
  NOTEBOOK_NOTES: 'notebook_notes_menu',
  CHAT: 'chat_menu',
};

export { Permissions, MenuPermissions };
